import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LiquidacionesStateService } from '../../services/liquidaciones-state.service';

@Component({
    selector: 'app-logout',
    imports: [RouterLink, MatButtonModule],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private router: Router,
        private liquidacionesState: LiquidacionesStateService
    ) {}

    ngOnInit() {
        // Cerrar sesión automáticamente
        this.authService.logout();
        // Limpiar estados de módulos (filtros, cliente seleccionado, paginación)
        this.liquidacionesState.clearAgenciaState();
        this.liquidacionesState.clearVdState();
        // Redirigir al login
        this.router.navigate(['/']);
    }
}